import {observer} from "mobx-react";
import {MobileContainerBox} from "../boxes/mobile-container/mobile-container.box";
import {UserIconBox} from "../boxes/icon/user-icon.box";
import {UserBankrollBox} from "../boxes/bankroll/user-bankroll.box";
import {FreePlayDotIndicatorBox} from "../boxes/free-play-dot-indicator/free-play-dot-indicator.box";
import {CyClass} from "../../../../../../common/cy-classes";
import {
    TOOLTIP_TARGET_HEADER_BANKROLL_BUTTON_MOBILE
} from "../../../../../services/tooltip/on-boarding-tooltip/on-boarding-tooltip-target-selectors";
import {withServices} from "../../../../../react-hooks/with-services";
import React from "react";
import {ComponentServicesPick} from "../../../../../services/component-services-pick";
import {useServices} from "../../../../../react-hooks/use-services.hook";


export interface HeaderWelcomeButtonsForAuthorizedUserMobileViewComponentProps extends ComponentServicesPick<'gameRunner' | 'userMenu'> {

}


const ComponentBody: React.FC<HeaderWelcomeButtonsForAuthorizedUserMobileViewComponentProps> = observer((props) => {
    const services = useServices();

    const onClick = () => {
        props.userMenu.openMenu();
    }

    const renderFreePlayIndicator = () => {
        if(!services.freePlay.hasVouchers) {
            return null;
        }
        return (
            <FreePlayDotIndicatorBox className={CyClass('cy-free-play-indicator-dot')}/>
        )
    }

    const bankroll = props.gameRunner.currentRunningGame?.totalUserBankroll ?? services.walletProxy.totalBankroll;

    return (
        <MobileContainerBox onClick={onClick}
                            className={TOOLTIP_TARGET_HEADER_BANKROLL_BUTTON_MOBILE}>
            <UserIconBox/>
            {renderFreePlayIndicator()}
            <UserBankrollBox className={CyClass('cy-mobile-header-bankroll')}>
                {services.currency.formatMoney(bankroll)}
            </UserBankrollBox>
        </MobileContainerBox>
    );
})


export const HeaderWelcomeButtonsForAuthorizedUserMobileViewComponent = withServices(ComponentBody, ['gameRunner', 'userMenu'])